import { useState } from "react";
import { Modal, Upload, Button, message, Alert, Table, Typography, Space } from "antd";
import { InboxOutlined, FilePdfOutlined } from "@ant-design/icons";
import { leerPdfPO } from "../../../../services/financiero/ingresosPO/ordenesServicioPOService";

const { Dragger } = Upload;
const { Text } = Typography;

export default function LeerPoPdfModal({ open, onClose, onUsarDatos }) {

  const [file, setFile] = useState(null);
  const [procesando, setProcesando] = useState(false);
  const [resultado, setResultado] = useState(null);

  const handleClose = () => {
    setFile(null);
    setResultado(null);
    onClose();
  };

  const handleProcesar = async () => {
    if (!file) {
      message.warning("Adjunte un archivo PDF");
      return;
    }
    setProcesando(true);
    try {
      const data = await leerPdfPO(file);
      setResultado(data);
    } catch (error) {
      message.error(error?.response?.data?.message || "Error procesando el PDF");
    } finally {
      setProcesando(false);
    }
  };

  const handleUsar = () => {
    onUsarDatos(resultado);
    handleClose();
  };

  const columns = [
    { title: "Producto (detectado)", dataIndex: "nombre_producto_ocr" },
    { title: "Cantidad", dataIndex: "cantidad", width: 100 },
    { title: "Valor unitario COP", dataIndex: "valor_unitario_COP", width: 150 }
  ];

  return (
    <Modal
      open={open}
      title="Leer PO desde PDF"
      onCancel={handleClose}
      width={800}
      footer={
        resultado
          ? [
            <Button key="volver" onClick={() => setResultado(null)}>Volver a intentar</Button>,
            <Button key="usar" type="primary" onClick={handleUsar}>
              Usar estos datos
            </Button>
          ]
          : [
            <Button key="cancelar" onClick={handleClose}>Cancelar</Button>,
            <Button key="procesar" type="primary" loading={procesando} onClick={handleProcesar}>
              Procesar PDF
            </Button>
          ]
      }
    >
      {!resultado ? (
        <>
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
            message="Se extraen automáticamente el número de PO, proveedor y líneas de producto. Debe revisar y completar los datos antes de guardar — nada se guarda todavía."
          />
          <Dragger
            multiple={false}
            accept=".pdf"
            maxCount={1}
            beforeUpload={(f) => {
              setFile(f);
              return false;
            }}
            onRemove={() => setFile(null)}
            fileList={file ? [file] : []}
          >
            <p className="ant-upload-drag-icon"><InboxOutlined /></p>
            <p className="ant-upload-text">Arrastre o seleccione el PDF de la orden de compra</p>
          </Dragger>
        </>
      ) : (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Alert
            type="warning"
            showIcon
            message="Revise cuidadosamente cada producto, cantidad y valor antes de guardar en el siguiente paso."
          />
          <Text><b>Número de PO detectado:</b> {resultado.numero_po || "No detectado"}</Text>
          <Text><b>Proveedor detectado:</b> {resultado.proveedor || "No detectado"}</Text>
          <Text><b>Fecha detectada:</b> {resultado.fecha || "No detectada"}</Text>
          <Table
            size="small"
            rowKey={(r, i) => i}
            columns={columns}
            dataSource={resultado.lineas || []}
            pagination={false}
          />
          {!resultado.lineas?.length && (
            <Alert
              type="error"
              showIcon
              icon={<FilePdfOutlined />}
              message="No se detectaron líneas de producto en una tabla reconocible del PDF. Puede continuar y digitarlas manualmente."
            />
          )}
        </Space>
      )}
    </Modal>
  );
}
